<template>
  <platLogin :login-type="1"></platLogin>
</template>

<script>
export default {
  components: {
    platLogin: () => import('./platLogin.vue')
  }
}
</script>